import { Wrench, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function ToolsPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Tools</h1>
          <p className="text-sm text-foreground-muted">Manage your 3D printing tools</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          Add Tool
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Wrench className="h-10 w-10" />}
          title="No tools yet"
          description="Track your printing tools like scrapers, cutters, tweezers, and maintenance equipment."
          actionLabel="Add Tool"
          onAction={() => {
            // TODO: Open add tool modal
          }}
        />
      </div>
    </div>
  );
}
